import { Link } from 'gatsby';

import { CollectionSlider, useSliderViewport } from '@mewa/ui';

import { jpgPath } from '../../helpers/image-factory';
import { CollectionProducts } from '../../helpers/product-grouping';
import Image from '../image';
import { ProductCardBaseData } from './product-card-base';
import { ProductCardColorSliderWrapper } from './product-card-color-slider-wrapper';

export const CollectionSliderWrapper = ({
  collection,
  langPrefix,
  collectionLinkLabel,
  detailsPageLabel,
}: {
  collection: CollectionProducts<ProductCardBaseData>;
  collectionLinkLabel: string;
  detailsPageLabel: string;
  langPrefix: string;
}) => {
  const sliderViewport = useSliderViewport();

  return (
    <CollectionSlider
      title={collection.name ?? undefined}
      subtitle={collection.claim ?? ' '}
      link={
        collection.slug
          ? {
              label: collectionLinkLabel,
              props: {
                to: `${langPrefix}/${collection.slug}`,
                component: Link,
              },
            }
          : undefined
      }
      emotion={
        collection.emotionAssetId ? (
          <Image
            alt={collection.name || ''}
            images={[
              {
                src: jpgPath(collection.emotionAssetId, 845, 633),
                media: `(min-width: 0px)`,
                width: 845,
                height: 633,
              },
            ]}
          />
        ) : undefined
      }
      slides={collection.products}
      renderSlide={(product) => (
        <ProductCardColorSliderWrapper
          key={product.uuid}
          useMbsFallbackIcon={true}
          product={product}
          langPrefix={langPrefix}
          detailsPageLabel={detailsPageLabel}
        />
      )}
      viewport={sliderViewport}
    />
  );
};
